export const Frequency = {
  MONTHLY: '1',
  QUARTERLY: '2',
  HALF_YEARLY: '3',
  ANNUALLY: '4'
};
